// Public (unauthenticated) AI-tool endpoints on the billing service —
// ATS Checker and Cover Letter drafting are free lead-gen tools, unlike
// the rest of api.ts which gates everything behind Firebase auth.
export const AI_API_BASE = "https://nohaya-billing-26730182444.us-central1.run.app";

export class AiToolError extends Error {}

async function parseOrThrow(res: Response): Promise<Record<string, unknown>> {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new AiToolError(typeof data.detail === "string" ? data.detail : `Request failed (${res.status})`);
  }
  return data;
}

export type AtsFinding = {
  category: "keywords" | "formatting" | "structure" | "impact";
  severity: "high" | "medium" | "low";
  issue: string;
  fix: string;
};

export type AtsCheckResult = {
  score: number;
  summary: string;
  findings: AtsFinding[];
};

export async function checkResumeAts(input: {
  file?: File;
  resumeText?: string;
  jobTitle?: string;
}): Promise<AtsCheckResult> {
  const fd = new FormData();
  if (input.file) fd.append("file", input.file);
  if (input.resumeText) fd.append("resumeText", input.resumeText);
  if (input.jobTitle) fd.append("jobTitle", input.jobTitle);

  const res = await fetch(`${AI_API_BASE}/ai/ats-check`, { method: "POST", body: fd });
  return (await parseOrThrow(res)) as unknown as AtsCheckResult;
}

export type CoverLetterDraft = {
  salutation: string;
  paragraphs: string[];
  closing: string;
};

export async function generateCoverLetter(input: {
  jobTitle: string;
  company: string;
  keyStrengths: string;
}): Promise<CoverLetterDraft> {
  const res = await fetch(`${AI_API_BASE}/ai/cover-letter/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  return (await parseOrThrow(res)) as unknown as CoverLetterDraft;
}
